import * as React from "react";
const SvgRight = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "#FDFDFD", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M2.5 8h11M9 3.5 13.5 8 9 12.5" }));
export default SvgRight;
